import React,{ useEffect, useState,useRef, ChangeEvent } from 'react'
import { Button,FormGroup,FormControl,Form,Col,Row,FormCheck, Alert, Modal, ButtonGroup } from 'react-bootstrap'
import { updateLayout} from 'open-sankey/dist/SankeyLayout'
import FileSaver from 'file-saver'
import { arrangeTrade, split_trade } from './SankeyTrade'
import { AFMSankeyData, AFMSankeyNode } from './types'
import * as d3 from 'd3'
import { reorganize_all_input_outputLinksId } from 'open-sankey/dist/SankeyLayout'
//import LZString from 'lz-string'

interface SupplyUseModelisationProdTypes {
  sankey_data: AFMSankeyData,
  set_sankey_data: (data:AFMSankeyData)=>void,
  show_reconciliation : boolean,
  set_show_reconciliation : (b:boolean)=>void,
  action_type: React.MutableRefObject<string>,
  uploadExcelImpl: (
    sankey_data: AFMSankeyData,
    set_sankey_data: (data:AFMSankeyData)=>void,
    f:()=>0,
    blob:BlobPart,
    r:string,
    f2:(sankey_data:AFMSankeyData)=>void
  ) => void
}

const SupplyUseModelisationProd = ({show_reconciliation,set_show_reconciliation,action_type,uploadExcelImpl,sankey_data,set_sankey_data} : SupplyUseModelisationProdTypes) => {
  const [result,setResult] = useState('')
  const [processing,setProcessing] = useState(false)
  const [failure,setFailure] = useState(false)
  const [not_started,setNotStarted] = useState(true)
  const [value,setValue] = useState([1,2])
  const [regions,setRegions] = useState(false)
  // const [action_type,setActionType] = useState('optim')
  const [uncertainty,setUncertainty] = useState(false)
  const [nb_realizations,setNbRealizations] = useState(100)
  const [excel_file,setExcelFile] = useState('')
  const [input_file_name,setInputFileName] = useState('')
  const [layout_file,set_layout_file] = useState<Blob|undefined>(undefined)
  const [input_file,set_input_file] = useState<Blob|undefined>(undefined)
  //let input_file_ =  useRef<HTMLInputElement>(null)
  let upper_level_file_ =  useRef<HTMLInputElement>(null)
  //let layout_file_=  useRef<HTMLInputElement>(null)
  //let layout_file_: Blob[] | undefined
  const setNbRealisations = (e:ChangeEvent) => {
    setNbRealizations((e.target as HTMLFormElement).value)
  }

  const uncertaintyChange = (e:ChangeEvent) => {
    setUncertainty((e.target as HTMLFormElement).checked)
  }

  const handleChange = (evt:MouseEvent) => {
    if ( value.includes(+(evt.target as HTMLFormElement).value) ) {
      value.splice(value.indexOf((evt.target as HTMLFormElement).value))
    } else {
      value.push(+(evt.target as HTMLFormElement).value)
    }
    setValue([...value])
  }

  const regionChange = (evt:ChangeEvent) => {
    setRegions((evt.target as HTMLFormElement).checked)
  }

  const setInputFile = (evt:ChangeEvent) =>{
    set_input_file((evt.target as HTMLFormElement).files[0])
  }

  const setLayoutFile = (evt:ChangeEvent) =>{
    set_layout_file((evt.target as HTMLFormElement).files[0])
  }

  const setRegionFile = (evt:ChangeEvent) => {
    upper_level_file_ = (evt.target as HTMLFormElement).files[0]
  }

  const retrievesResults = () => {
    //const { action_type, excel_file } = this.state

    const path = window.location.href
    const url = path + 'optimize_retrieves_result'
    const form_data = new FormData()
    form_data.append('excel_file', excel_file)
    const fetchData = {
      method: 'POST',
      body: form_data
    }
    //const input_file_name = (input_file_.current as any).name 
    const root_file_name = input_file_name.split('.')[0]
    let suffix = '_reconciled.xlsx'
    if (action_type.current === 'check_excel') {
      suffix = '_corrected.xlsx'
    } else if ( action_type.current === 'create_empty_ter') {
      suffix = '_ter_created.xlsx'
    }
    const file_name = root_file_name + suffix
    function showFile(blob:BlobPart){
      const newBlob = new Blob([blob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      FileSaver.saveAs(newBlob, file_name)
      return newBlob
    }
    const layout = Object.assign({},sankey_data)
    fetch(url, fetchData).then(
      function(response) {
        if(response.ok) {
          if (action_type.current === 'check_excel') {
            if (response.status === 201 ) {
              return
            }
            response.blob().then(showFile)
          } else {
            response.blob()
              .then(showFile)
              .then(
                (blob: BlobPart)=>uploadExcelImpl(sankey_data,set_sankey_data,()=>0,blob,'results',(new_sankey_data:AFMSankeyData)=>{ 
                  if (layout_file === undefined) {
                    if (new_sankey_data.trade_sectors.length > 0) {
                      new_sankey_data.trade_sectors.forEach( (trade_sector) => {
                        split_trade(trade_sector+ ' - Importations', new_sankey_data )
                        split_trade(trade_sector+ ' - Exportations', new_sankey_data )
                      })
                      const scale = d3.scaleLinear()
                        .domain([0, +new_sankey_data.user_scale])
                        .range([0, 100])
                      Object.values(new_sankey_data.nodes).forEach((n)=>{
                        (n as AFMSankeyNode).trade_close=true
                        //n.position='relative'
                      })
                      arrangeTrade(new_sankey_data,scale)
                    }
                    if (action_type.current === 'optim_sankey') {
                      updateLayout(new_sankey_data, layout)
                    } else {
                      reorganize_all_input_outputLinksId(new_sankey_data.nodes,new_sankey_data.links)
                    }
                    action_type.current = ''
                    setNotStarted(true)
                    set_show_reconciliation(false)
                    return
                  }
                  const reader = new FileReader()
                  reader.onload = (() => {
                    action_type.current = ''
                    setNotStarted(true)
                    set_show_reconciliation(false)
                    return (
                      (e: ProgressEvent<FileReader>) => {
                        let result = (e.target as FileReader).result
                        if (result) {
                          result = String(result).split('<br>').join('\\\\n')
                          const data : AFMSankeyData = JSON.parse(result)
                          if (sankey_data.trade_sectors.length > 0) {
                            sankey_data.trade_sectors.forEach( (trade_sector) => {
                              split_trade(trade_sector+ ' - Importations', sankey_data )
                              split_trade(trade_sector+ ' - Exportations', sankey_data )
                            })
                            const scale = d3.scaleLinear()
                              .domain([0, +data.user_scale])
                              .range([0, 100])
                            Object.values(sankey_data.nodes).forEach((n)=>{
                              (n as AFMSankeyNode).trade_close=true
                              //n.position='relative'
                            })
                            arrangeTrade(sankey_data,scale)
                          }
                          updateLayout(sankey_data, data)
                          set_sankey_data({...sankey_data})
                          // if (sankey_data.agregation.level === -1 ) {
                          //   localStorage.setItem('initial_data',LZString.compress(JSON.stringify(sankey_data)))
                          // }
                        }
                      }
                    )
                  })()
                  reader.readAsText(layout_file)
                })
              )
          }
        } else {
          response.json().then(function (data) {
            setResult(data.output)
            setFailure(true)
          }).catch( function() {
            setResult(result + '\n ERROR: optimize_retrieves_result a retourné une erreur qui n\'est pas en format json')
            setFailure(true)
          })
          action_type.current = ''
          setNotStarted(true)
        }
      }
    )

  }

  const reset = () => {
    setProcessing(false)
    setFailure(false)
    setNotStarted(true)  
  }

  // const prodProcessResponse = (response:any) => {
  //   // var {result } = this.state
  //   // var that = this
  //   if(response.ok) {
  //     response.json().then(function (data:any) {
  //       setResult(data.output)
  //       setFailure(false)
  //     })
  //   } else {
  //     response.json().then(function (data:any) {
  //       setResult(data.output)
  //       setFailure(true)
  //     }).catch( function() {
  //       setResult(result + '\n ERROR: optimize_prod_process a retourné une erreur qui n\'est pas en format json')
  //       setFailure(true)
  //     })
  //   }
  // }

  const launchReconciliation = () => {
    //var { action_type,uncertainty,nb_realizations} = this.state


    const data = new FormData()
    data.append('input_file', input_file as Blob)
    data.append('optim_sankey', String(action_type.current === 'optim_sankey') )
    data.append('create_empty_ter', String(action_type.current  === 'create_empty_ter') )
    data.append('check_excel', String(action_type.current  === 'check_excel'))
    data.append('uncertainty_analysis', String(uncertainty))
    data.append('nb_realizations', String(nb_realizations) )
    data.append('upper_level_file', (upper_level_file_ as unknown as HTMLFormElement).name)
    if ( action_type.current  === 'optim_sankey') {
      const new_sankey_data = JSON.parse(JSON.stringify(sankey_data))
      new_sankey_data.icon_catalog = {}
      data.append('sankey_data',JSON.stringify(new_sankey_data))
    }
    const path = window.location.href
    const url = path + 'optimize_prod_launch'
    const fetchData = {
      method: 'POST',
      body: data
    }

    // var that = this

    fetch(url, fetchData).then(
      function(response) {
        if(response.ok) {
          response.json().then(function (data) {
            setExcelFile(data['excel_input_file']) 
          })
        }
      }
    )
    setProcessing(true)
    setFailure(true)
    setNotStarted(false)
    setResult('')
    if (input_file) {
      setInputFileName((input_file as unknown as {name:string}).name)
    }
  }

  const finishReconciliation = (failure:boolean) => {
    //const { result} = this.state
    const path = window.location.href
    // var url = path + 'optimize_prod_process'
    // var fetchData = {
    //   method: 'POST',
    //   body: ''
    // }


    // fetch(url, fetchData).then(that.prodProcessResponse).catch(function() {
    //   that.setState({ 
    //     result: result + '\n ERROR: optimize_prod_process: erreur fatale.',
    //     failure : true 
    //   })
    // })
    const url = path + 'optimize_prod_clean'
    const fetchData = {
      method: 'POST',
      body: ''
    }
    fetch(url, fetchData).then(
      function(response) {
        if(!response.ok) {
          setResult(result + '\n ERROR: optimize_prod_clean a retourné une erreur qui n\'est pas en format json')
          setFailure(true)
        } else {
          setProcessing(false)
          setFailure(failure)
          setNotStarted(false)
        }
      }
    ).catch(function() {
      setResult(result + '\n ERROR: optimize_prod_clean: erreur fatale.')
      setFailure(true)
    // that.setState({
    //   processing : false,
    //   failure : false
    // })
    //     })
    //     } else {
    //       response.json().then(function (data) {
    //         that.setState(
    //           { result: result + data.output,
    //             processing : false,
    //             failure : true
    //           })
    //       }).catch(function() {
    //         that.setState(
    //           { result: result + '\n Le serveur a retourné une erreur qui n\'est pas en format json' ,
    //             processing : false,
    //             failure : true
    //           })
    //       })
    //     }
    //   }
    // ).catch(function() {
    //   that.setState(
    //     { result: result + '\n ERROR: optimize_prod_launch: erreur fatale.',
    //       processing : false,
    //       failure : true 
    //     })
    // })
    })  
  }
  //var {result,processing,value,failure,not_started,regions,uncertainty,nb_realizations } = this.state
  const infos = result !== undefined ? result.split('\n') : []
  //const { action_type } = this.state
  let title = 'Réconciliation des données'
  if (action_type.current  === 'check_excel' ) {
    title = 'Vérification du fichier d\'entrée'
  } else if (action_type.current  === 'create_empty_ter' ) {
    title = 'Création de la table Ressources Emplois'
  }
  let success_status = 'Succés de la réconciliation'
  if (action_type.current  === 'check_excel' ) {
    success_status = 'Vérification terminée'
  } else if (action_type.current  === 'create_empty_ter' ) {
    success_status = 'Création Terminée'
  }
  let failure_status = 'Echec de la réconciliation'
  if (action_type.current  === 'check_excel' ) {
    failure_status = 'Echec de la vérification'
  } else if (action_type.current  === 'create_empty_ter' ) {
    failure_status = 'Echec de la création'
  }

  useEffect(() => {
    if (not_started && action_type.current === 'optim_sankey') { launchReconciliation()}
  })

  return (
    <Modal 
      bsSize="large" 
      show={show_reconciliation} 
      onHide={ () => set_show_reconciliation(false) }
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Modal.Header closeButton>
        <Modal.Title>Reconciliation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form >
          <FormGroup>
            { action_type.current  !== 'optim_sankey' ? (<>
              <Row>
                <Col sm={12}><h3 style={{textAlign:'center'}}>Paramétres et données d&apos;entrée</h3></Col> 
              </Row>
              <Row>
                <Col><p style={{textAlign:'left'}}>Fichier d&apos;entrée excel</p></Col>   
                <Col>     
                  <Form.Control
                    type="file"
                    //ref={input_file_}                
                    name=""
                    onChange={setInputFile}
                  />  
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label>Layout</Form.Label>
                </Col>
                <Col>
                  <Form.Control
                    type="file"
                    //ref={layout_file_}                
                    name=""
                    onChange={setLayoutFile}
                  /></Col>
              </Row></>
            ) : (<></>)}
            { action_type.current  === 'optim' ? (
              <Row>
                <Col sm={3}>                  
                  <FormCheck 
                    type='checkbox'  
                    name="regions" 
                    value='0' 
                    id="regions"
                    label="Descente d&apos;échelle"
                    onChange={regionChange}                   
                  >
                  </FormCheck>
                </Col> 
              </Row>) : (<div></div>)}
            {regions &&  action_type.current  === 'optim' ? (
              <Row>
                <Col sm={3}><p style={{textAlign:'left'}}>Fichier MFA du niveau géographique supérieur</p></Col>  
                <Col sm={3}>     
                  <FormControl              
                    type="file" name=""
                    onChange={setRegionFile}
                  />  
                </Col>
              </Row>) : (<div></div>)}
            { action_type.current  === 'optim' ? (
              <Row>
                <Col sm={3}>   

                  <FormCheck 
                    type='checkbox' 
                    name="uncertainty" 
                    checked={uncertainty} 
                    id="uncertainty"
                    label='Analyse d&apos;incertitude'
                    onChange={uncertaintyChange}                   
                  >
                  </FormCheck>
                </Col>
              </Row>
            ) : (<div></div>)}
            {uncertainty && action_type.current  === 'optim' ? (
              <Row>
                <Col sm={3} ><p style={{textAlign:'left'}}>Nombre de réalisations</p></Col>  
                <Col sm={3}>     
                  <FormControl 
                    disabled={!uncertainty}
                    value={nb_realizations}             
                    type="text" name=""
                    onChange={setNbRealisations}
                  />  
                </Col>
              </Row>) : (<div></div>)}
            <hr/> 
            <Row>
              <Col sm={12}><h3 style={{textAlign:'center'}}>{title}</h3></Col> 
            </Row>
            <br/>
            <br/>              
            <br/>  
            <Row>  
              <Col sm={2}>         
                {not_started ? (<Button variant="primary" onClick={launchReconciliation}>Lancer</Button>) :   
                  processing ? (
                    <Button variant="warning"><span className="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> En traitement...</Button>):(
                    failure ? 
                      <Button variant="danger" onClick={reset}>{failure_status}</Button> : 
                      <Button variant="success" onClick={retrievesResults}>{success_status}</Button>
                  )}
              </Col></Row> 
            {!not_started&&!processing&&!failure ?(<Row>  
              <Col sm={12}> 
                <Alert>Cliquer pour télécharger les résultats.</Alert>
              </Col></Row> ):(<div/>)}
            <hr/> 
            <Row>
              <Col sm={12}><h3 style={{textAlign:'center'}}>Terminal</h3></Col> 
            </Row>
            <br/>              
            <br/>
            <Row>
              <Col sm={12}>
                <ButtonGroup>
                  <Button onClick={evt=>handleChange(evt as unknown as MouseEvent)} value={1} variant={value.includes(1) ? 'info' : 'light'} >Infos</Button>
                  <Button onClick={evt=>handleChange(evt as unknown as MouseEvent)} value={2} variant={value.includes(2) ? 'danger' : 'light'} >Erreurs</Button>
                  <Button onClick={evt=>handleChange(evt as unknown as MouseEvent)} value={3} variant={value.includes(3) ? 'warning' : 'light'} >Debug</Button>
                </ButtonGroup></Col>
            </Row>
            {processing ? (
              <Counter 
                finishReconciliation={finishReconciliation}
                value={value}
                result={result}
                setResult={setResult} 
              />
            ) : (
              <Row >
                <Col sm={12} >
                  {infos.map(
                    (info) => (
                      value.includes(2) && info.includes('ERROR') ?
                        (<div style={{color:'red'}}>{info.replace('ERROR','')}</div>)
                        : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                          (<div style={{color:'blue'}}>{info.replace('INFO','')}</div>)
                          : value.includes(3) && (info.includes('DEBUG') ) ? 
                            (<div style={{color:'orange'}}>{info.replace('DEBUG','')}</div>) : (null)
                    )
                  )
                  }
                </Col>
              </Row>
            )}
          </FormGroup>
        </Form>
      </Modal.Body>
    </Modal>
  )
}


const Counter = ({finishReconciliation,value,result,setResult}:{finishReconciliation:(x:boolean)=>void,value:number[],result:string,setResult:(x:string)=>void}) => {
  useEffect(() =>{
    const interval = setInterval(() => {
      const path = window.location.href
      const url = path + 'optimize_prod_process'
      const fetchData = {
        method: 'POST',
        body: ''
      }
      fetch(url, fetchData).then(
        function(response) {
          if(response.ok) {
            response.json().then(
              function (data) {
                setResult(data.output)
              }
            )
          }  
        })
    }, 5000)
    return () => clearInterval(interval)
  })
  //let {value, result} = parent
  const infos = result !== undefined ? result.split('\n') : []
  if ( infos.length > 2) {
    const info = infos[infos.length-2]
    if (info.includes('FINISHED')) {
      finishReconciliation(false)
    } else if (info.includes('FAILED')) {
      finishReconciliation(true)
    }
  }
  return (
    <Row >
      <Col sm={12} >
        {infos.map(
          info => (
            value.includes(2) && info.includes('ERROR') ?
              (<div style={{color:'red'}}>{info.replace('ERROR','')}</div>)
              : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                (<div style={{color:'blue'}}>{info.replace('INFO','')}</div>)
                : value.includes(3) && (info.includes('DEBUG') ) ? 
                  (<div style={{color:'orange'}}>{info.replace('DEBUG','')}</div>) : (null)
          )
        )
        }
      </Col>
    </Row>
  )
}

export default SupplyUseModelisationProd
